import { render, staticRenderFns } from "./grouppurchasing.vue?vue&type=template&id=36aec65a&scoped=true&"
import script from "./grouppurchasing.vue?vue&type=script&lang=js&"
export * from "./grouppurchasing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36aec65a",
  null
  
)

export default component.exports